import { idbDeleteDatabase } from './idb.js';

/**
 * Cleanup-Hook für die Crypto-Pipeline nach Erreichen eines End-Zustands
 * (`SUCCESS`, `BUSINESS_ERROR`, `TECHNICAL_ERROR`).
 *
 * Löscht die komplette `pinkCancel`-IndexedDB statt nur den Eintrag — so
 * bleibt kein Object-Store stehen, der versehentlich beim nächsten Aufruf
 * Reste enthält.
 */
export async function clearPatientKeysFromIDB(): Promise<void> {
  await idbDeleteDatabase();
}
